<div class="ntv-autocomplete" [style.width]="width()">
    <!-- Label -->
    @if (config().label) {
        <div class="ntv-autocomplete__header">
            <label class="ntv-autocomplete__label">
                {{ config().label }}
            </label>
            @if (error()) {
                <span class="ntv-autocomplete__error-text">{{ error() }}</span>
            }
        </div>
    }

    <!-- Trigger Box -->
    <div
        class="ntv-autocomplete__trigger"
        [class.ntv-autocomplete__trigger--open]="isOpen()"
        [class.ntv-autocomplete__trigger--disabled]="isDisabled()"
        [class.ntv-autocomplete__trigger--error]="error()"
        (click)="toggleDropdown($event)"
        (focusin)="onTriggerFocus()"
        tabindex="0">
        <div class="ntv-autocomplete__selection-container">
            <!-- Search Input (if searchable and open) -->
            @if (config().searchable && isOpen()) {
                <input
                    type="text"
                    class="ntv-autocomplete__search-input"
                    [formControl]="searchControl"
                    [placeholder]="config().placeholder || 'Search...'"
                    (click)="$event.stopPropagation()"
                    autofocus />
            } @else {
                <!-- Display Label (if not searching or not searchable) -->
                <span
                    class="ntv-autocomplete__display-value"
                    [class.ntv-autocomplete__display-value--placeholder]="
                        selectedOptions().length === 0
                    ">
                    {{ dropdownLabel() }}
                </span>
            }
        </div>

        <!-- Icons -->
        <div class="ntv-autocomplete__icons">
            @if (selectedOptions().length > 0) {
                <button
                    type="button"
                    class="ntv-autocomplete__icon-btn"
                    (click)="clearSelection($event)">
                    <svg width="14" height="14">
                        <use href="assets/icons/icons-sprite.svg#close"></use>
                    </svg>
                </button>
            }
            <div class="ntv-autocomplete__chevron" [class.ntv-autocomplete__chevron--up]="isOpen()">
                <svg width="14" height="14" color="gray">
                    <use href="assets/icons/icons-sprite.svg#chevron"></use>
                </svg>
            </div>
        </div>
    </div>

    <!-- Dropdown Content -->
    @if (isOpen()) {
        <div class="ntv-autocomplete__dropdown">
            <!-- Loading State -->
            @if (loading()) {
                <div class="ntv-autocomplete__loading">
                    <div class="ntv-autocomplete__spinner"></div>
                    <span>Loading...</span>
                </div>
            } @else {
                <!-- Options List -->
                @if (options().length > 0) {
                    <ul class="ntv-autocomplete__options" (scroll)="onListScroll($event)">
                        @for (
                            option of options();
                            track option.selectionKey ?? option.value ?? $index
                        ) {
                            <li
                                class="ntv-autocomplete__option"
                                [class.ntv-autocomplete__option--selected]="isSelected(option)"
                                (click)="selectOption(option, $event)">
                                <!-- Checkbox for multi-select -->
                                @if (config().multiple) {
                                    <div class="ntv-autocomplete__checkbox">
                                        <div
                                            class="ntv-autocomplete__checkbox-inner"
                                            [class.ntv-autocomplete__checkbox-inner--checked]="
                                                isSelected(option)
                                            ">
                                            @if (isSelected(option)) {
                                                <svg width="14" height="14" color="white">
                                                    <use
                                                        href="assets/icons/icons-sprite.svg#check"></use>
                                                </svg>
                                            }
                                        </div>
                                    </div>
                                }

                                @if (getIcon(option)) {
                                    <span class="ntv-autocomplete__option-icon">
                                        <svg
                                            [attr.width]="getIconSize(option)"
                                            [attr.height]="getIconSize(option)"
                                            color="black">
                                            <use
                                                [attr.xlink:href]="
                                                    'assets/icons/icons-sprite.svg#' +
                                                    getIcon(option)
                                                "></use>
                                        </svg>
                                    </span>
                                }

                                <span class="ntv-autocomplete__option-label">{{
                                    getOptionLabel(option)
                                }}</span>
                            </li>
                        }
                        @if (loadingMore()) {
                            <li class="ntv-autocomplete__loading-more">
                                <div class="ntv-autocomplete__spinner"></div>
                                <span>Loading more...</span>
                            </li>
                        }
                    </ul>
                } @else {
                    <!-- Empty State -->
                    <div class="ntv-autocomplete__empty">No options found</div>
                }
            }
        </div>
    }
</div>
